import Swiper from 'swiper';
import { TimelineMax } from 'gsap/TweenMax';
import checkZero from '@/scripts/utils/lead-zero';

export default function () {
  const $coverSlider = $('[data-type*="cover-slider"]');
  if (!$coverSlider.length) return;
  const $fractionPagination = $coverSlider.find('[data-type*="cover-slider-fraction"]');
  const $progressPagination = $coverSlider.find('[data-type*="cover-slider-progress"]');
  const $slider = $coverSlider.find('[data-type*="cover-slider-slides"]');
  const $slides = $slider.find('.swiper-slide');
  const textAnimationSelector = '[data-slide-animation="slide-text-animation"]';
  const tl = new TimelineMax();

  const swiperConfig = {
    autoplay: {
      delay: 5000,
    },
    loop: false,
    effect: 'fade',
    speed: 2000,
    pagination: {
      el: $progressPagination,
      type: 'progressbar',
    },
    on: {
      init: () => {
        const fraction = `<span data-type="active-slide">01</span><span class="divider">&nbsp;/&nbsp;</span><span>${checkZero($slides.length)}</span>`;
        $fractionPagination.html(fraction);
        const textAnimations = $slider.find(textAnimationSelector);
        textAnimations.each((i, el) => {
          if (i !== 0) {
            const items = $(el).children();
            tl.set(items, { autoAlpha: 0, x: -200 });
          }
        });
      },
    },
  };

  if (!$slider.length) return;

  const swiper = new Swiper($slider, swiperConfig);
  const activeSlide = $coverSlider.find('[data-type*="active-slide"]');

  swiper.on('transitionStart', () => {
    activeSlide.text(checkZero(swiper.realIndex + 1));
    const $itemsPrevSlide = $($slides[swiper.previousIndex]).find(textAnimationSelector).children();
    const $itemsNextSlide = $($slides[swiper.realIndex]).find(textAnimationSelector).children();

    tl
      .staggerTo($itemsPrevSlide, 0.8, { autoAlpha: 0, x: 200 }, 0.2)
      .staggerTo($itemsNextSlide, 0.8, { autoAlpha: 1, x: 0 }, 0.2)
      .set($itemsPrevSlide, { autoAlpha: 0, x: -200 });
  });
}



// WEBPACK FOOTER //
// ./scripts/blocks/cover-slider.js